<script setup>
import { onMounted, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import { usePromotionalCampaigns } from 'dashboard/composables/usePromotionalCampaigns';

const { t } = useI18n();
const {
  currentCampaign,
  fetchEligibleCampaigns,
  logEvent,
  dismissCurrentCampaign,
} = usePromotionalCampaigns();

const shownAt = ref(null);

onMounted(fetchEligibleCampaigns);

watch(
  currentCampaign,
  campaign => {
    if (!campaign) return;
    shownAt.value = Date.now();
    logEvent(campaign.id, { eventType: 'shown' });
  },
  { immediate: true }
);

const onLinkClick = () => {
  logEvent(currentCampaign.value.id, { eventType: 'clicked' });
};

const onClose = () => {
  const durationSeconds = Math.round((Date.now() - shownAt.value) / 1000);
  logEvent(currentCampaign.value.id, { eventType: 'closed', durationSeconds });
  dismissCurrentCampaign();
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div
    v-if="currentCampaign"
    class="fixed inset-0 z-[9990] flex items-center justify-center bg-n-alpha-black2 backdrop-blur-[4px]"
  >
    <div
      class="relative w-[28rem] max-w-[90vw] overflow-hidden rounded-xl bg-n-solid-2 shadow-md"
    >
      <Button
        ghost
        slate
        icon="i-lucide-x"
        class="absolute z-10 ltr:right-2 rtl:left-2 top-2"
        :aria-label="t('GENERAL.CLOSE')"
        @click="onClose"
      />
      <img
        v-if="currentCampaign.imageUrl"
        :src="currentCampaign.imageUrl"
        alt=""
        class="w-full object-cover max-h-60"
      />
      <div class="p-6 flex flex-col gap-3">
        <h3 class="text-lg font-semibold text-n-slate-12">
          {{ currentCampaign.title }}
        </h3>
        <p class="text-sm text-n-slate-11 whitespace-pre-line">
          {{ currentCampaign.body }}
        </p>
        <a
          v-if="currentCampaign.linkUrl"
          :href="currentCampaign.linkUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center justify-center rounded-lg bg-n-brand px-4 py-2 text-sm font-medium text-white hover:opacity-90"
          @click="onLinkClick"
        >
          {{ currentCampaign.linkLabel || t('GENERAL.LEARN_MORE') }}
        </a>
      </div>
    </div>
  </div>
</template>
